import React from 'react';
import { siteContent } from '../data/mock';

const ForWho = () => {
  const { forWho } = siteContent;

  return (
    <section className="py-24 bg-neutral-50">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-medium text-neutral-900 mb-12">
          {forWho.title}
        </h2>
        <ul className="space-y-2 mb-10">
          {forWho.list.map((item) => (
            <li key={item} className="text-lg text-neutral-700">— {item}</li>
          ))}
        </ul>
        <p className="text-lg text-neutral-700 leading-relaxed">
          {forWho.body}
        </p>
        </div>
      </div>
    </section>
  );
};

export default ForWho;
